module.exports = __webpack_public_path__ + "img/option_icon.bec10e9b.svg";